import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import { OrderWithItems, ShoppingCartWithItems } from 'common-models';
import { FC, useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { Model } from 'src/lib/Model';
import { OrdersList } from '../../../components/Admin/OrdersList';
import { ShoppingCartsList } from '../../../components/Admin/ShoppingCartsList';
import { useDeleteShoppingCartMutation, useGetAllOrdersQuery, useGetAllShoppingCartsQuery } from '../../../features/events/eventShopApiSlice';



const ShopAdminPage: FC<any> = () => {
    const auth = useAuth();


    const { data: shoppingCartsFromApi = [], isLoading: shoppingCartsAreLoading } = useGetAllShoppingCartsQuery(auth.user?.access_token ?? '');
    const { data: ordersFromApi = [], isLoading: ordersAreLoading } = useGetAllOrdersQuery(auth.user?.access_token ?? '');
    const [deleteShoppingCart] = useDeleteShoppingCartMutation();

    const [shoppingCarts, setShoppingCarts] = useState(
        [] as Array<ShoppingCartWithItems>
    );

    const [orders, setOrders] = useState(
        [] as Array<OrderWithItems>
    );

    useEffect(() => {
        if (!shoppingCartsAreLoading) {
            setShoppingCarts(shoppingCartsFromApi.map(Model.deepCopyShoppingCartWithItems))
        }
    }, [shoppingCartsAreLoading, shoppingCartsFromApi]);


    useEffect(() => {
        if (!ordersAreLoading) {
            setOrders(ordersFromApi.map(Model.deepCopyOrderWithItems))
        }
    }, [ordersAreLoading, ordersFromApi]);

    const deleteCart = async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        const cartId = event.currentTarget.value;
        if (window.confirm(`Do you really want to remove cart with id '${cartId}'`)) {
            await deleteShoppingCart([cartId, auth.user?.access_token ?? '']);
        }
    }

    function getCurrentCartState(cart: ShoppingCartWithItems) {
        const sortedStates = cart.stateEvents
            // sort descending
            .sort((a, b) => b.time.valueOf() - a.time.valueOf())

        const state = sortedStates[0];
        // return first item (which is the latest one)
        return <Grid container><Grid size="auto">{state.state}</Grid><Grid size="auto"> {(new Date(state.time)).toISOString()}</Grid></Grid>;
    }

    return (
        <Root>
            <ShoppingCartsList
                shoppingCarts={shoppingCarts}
                onDeleteCart={deleteCart}
                getCurrentCartState={getCurrentCartState}
            />
            <OrdersList orders={orders} />
        </Root>
    )
    // }
}



const PREFIX = 'ShopAdminPage';
const classes = {
    cartFrame: `${PREFIX}-cartFrame`,
    urlTextField: `${PREFIX}-urlTextField`,
}

const Root = styled('div')(({ theme }) => ({
    [`&.${classes.cartFrame}`]: {
        borderStyle: 'solid',
        borderWidth: '1px',
        borderColor: theme.palette.text.secondary,
        borderRadius: '0.3rem',
        margin: '0.5rem'
    }, [`&.${classes.urlTextField}`]: {
        width: '50rem'
    },
}));

export default ShopAdminPage;
